import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";
import { VERIF_NAMES } from "../utils/permintaan-minyak-helpers";

// all the keys are declared up front: SignatureBox calls .includes on the list of its signature
const generateDefaultVerifSetting = (jabatanId = -1) => {
  const setting = { jabatan_id: jabatanId };
  VERIF_NAMES.forEach((name) => {
    setting[name] = [];
  });
  return setting;
};

// signatures of the document: label of /api/user/verif = permintaan_minyak:<name>
export const useAPIVerifPermintaanMinyak = () => {
  const uiContext = useContext(UiContext);
  const employee = useSelector((state) => state.auth.employee);
  const { requestGet, requestPost, loading } = useAPIRequest();

  const [verifSetting, setVerifSetting] = useState(
    generateDefaultVerifSetting()
  );

  //  API call section

  // who may sign what (the master Verify Setting)
  const fetchVerifSetting = async () => {
    return requestGet({
      fullUrl: "/api/masterdata/verifsetting/data",
      params: { filter: `label:contains:permintaan_minyak%` },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        const newVerifSetting = generateDefaultVerifSetting(
          employee?.jabatan_id ?? -1
        );
        for (const verifData of data ?? []) {
          const { label, jabatan_id } = verifData;
          const verifName = label.replace(`permintaan_minyak:`, "").trim();
          if (newVerifSetting[verifName]) {
            newVerifSetting[verifName].push(jabatan_id);
          }
        }
        setVerifSetting(newVerifSetting);
      },
    });
  };

  // sign one step; username + password are filled when someone else authorizes
  const verify = async ({ id, name, username, password }) => {
    const body = { data_id: id, label: `permintaan_minyak:${name}` };
    if (username) body["username"] = username;
    if (password) body["password"] = password;

    return await requestPost({
      fullUrl: `/api/user/verif`,
      body: body,
      onSuccess: ({ message, data }) => {
        uiContext.showSuccessMsg("Success", "Verifikasi berhasil");
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  return { loading, verifSetting, fetchVerifSetting, verify };
};
